import type { Brand } from '@lighthouse/core'
import { SpaceVersion } from '@lighthouse/core'

import { getBrand } from '../utils'

export enum spaceVersionEnum {
    FREE,
    BASIC,
    STANDARD,
    ADVANCED,
    PROFESSIONAL,
    ENTERPRISE,
    ULTIMATE
}

export const spaceGradeNameMap: Record<SpaceVersion, string> = {
    [SpaceVersion.ULTIMATE]: '旗舰版',
    [SpaceVersion.ENTERPRISE]: '企业版',
    [SpaceVersion.PROFESSIONAL]: '专业版',
    [SpaceVersion.ADVANCED]: '高级版',
    [SpaceVersion.STANDARD]: '标准版',
    [SpaceVersion.BASIC]: '基础版',
    [SpaceVersion.FREE]: '免费版'
}
export const spaceGradeIconMap: Record<SpaceVersion, string> = {
    [SpaceVersion.ULTIMATE]: 'CrownStar',
    [SpaceVersion.ENTERPRISE]: 'Flag',
    [SpaceVersion.PROFESSIONAL]: 'Earth',
    [SpaceVersion.ADVANCED]: 'Publish',
    [SpaceVersion.STANDARD]: 'Favourite',
    [SpaceVersion.BASIC]: 'EmojiFunnyCircle',
    [SpaceVersion.FREE]: 'EmojiFunnyCircle'
}

export const spaceGradeCodeMap: Record<SpaceVersion, spaceVersionEnum> = {
    [SpaceVersion.ULTIMATE]: 6,
    [SpaceVersion.ENTERPRISE]: 5,
    [SpaceVersion.PROFESSIONAL]: 4,
    [SpaceVersion.ADVANCED]: 3,
    [SpaceVersion.STANDARD]: 2,
    [SpaceVersion.BASIC]: 1,
    [SpaceVersion.FREE]: 0
}

export const spaceGradeUploadLimitMap: Record<SpaceVersion, spaceVersionEnum> = {
    [SpaceVersion.ULTIMATE]: 1024 * 1024 * 1024 * 5,
    [SpaceVersion.ENTERPRISE]: 1024 * 1024 * 1024 * 5,
    [SpaceVersion.PROFESSIONAL]: 1024 * 1024 * 1024 * 3,
    [SpaceVersion.ADVANCED]: 1024 * 1024 * 1024,
    [SpaceVersion.STANDARD]: 1024 * 1024 * 100,
    [SpaceVersion.BASIC]: 1024 * 1024 * 20,
    [SpaceVersion.FREE]: 1024 * 1024 * 5
}

export type SpaceVideoMaxQuality = 'SD' | 'HD' | 'FHD' | 'UHD'

// 与 SpaceUpgrade/SPACE_LEVEL_DATA 对齐：FREE~ADVANCED 为 HD，PROFESSIONAL~ULTIMATE 为 FHD
export const spaceGradeVideoMaxQualityMap: Partial<Record<SpaceVersion, SpaceVideoMaxQuality>> = {
    [SpaceVersion.FREE]: 'HD',
    [SpaceVersion.BASIC]: 'HD',
    [SpaceVersion.STANDARD]: 'HD',
    [SpaceVersion.ADVANCED]: 'HD',
    [SpaceVersion.PROFESSIONAL]: 'FHD',
    [SpaceVersion.ENTERPRISE]: 'FHD',
    [SpaceVersion.ULTIMATE]: 'FHD'
}

export const DEFAULT_BYECODE_SPACE_VERSION: SpaceVersion = SpaceVersion.FREE

const defaultBrandMap: Record<Brand, SpaceVersion> = { BYE_CODE: SpaceVersion.FREE }

export const DEFAULT_SPACE_VERSION: SpaceVersion = defaultBrandMap[getBrand()]
